export const NAVBAR_SCROLL_THRESHOLD = 80;
export const NAVBAR_FADED_OPACITY = 0.5;
export const NAVBAR_FULL_OPACITY = 1;
export const NAVBAR_OPACITY_TRANSITION_MS = 300;

/**
 * Fixed-height dev EnvBanner. `height` is the banner's own height; the other
 * two MUST stay numerically equal to it (Tailwind can't derive them):
 * - `pagePadding` reserves that space on the page root so the fixed banner
 *   never overlaps content.
 * - `stickyOffset` pushes the landing page's `sticky` navbar down by the same
 *   amount so it tucks below the banner instead of sliding behind it.
 * All three resolve to 1.5rem / 24px.
 */
export const ENV_BANNER = {
  height: "h-6",
  pagePadding: "pt-6",
  stickyOffset: "top-6",
} as const;
